export default __webpack_public_path__ + "static/media/home.ef02bef1.svg";